import type { OwaDate } from '../../../schema';
import { GlobalCalendarLocale, GlobalCalendarLanguage } from '../../../intl/globalCalendarLocale';
import getIntlDateBase from '../base/getIntlDateBase';
import convertNumberToHebrew from './convertNumberToHebrew';

export default function getIntlDateHebrew(
    date: OwaDate,
    locale: GlobalCalendarLocale,
    format: 'numeric' | '2-digit'
): string {
    const result = getIntlDateBase(date, locale, format);

    if (locale.calendarLanguage == GlobalCalendarLanguage.Hebrew) {
        // Convert to Hebrew numerals and hide the gershayim (similar to double quotes)
        // which indicate a number rather than a word.  We do not display this for dates.
        return convertNumberToHebrew(Number(result), true /* hideNumberIndicator */);
    }

    return result;
}
